<template>
<span v-show="visible" style="display:flex; position:absolute; z-index: 1; top: 10px; left: 10px;">
  <el-tooltip effect="dark" content="Smart Analyzer" placement="bottom">
    <el-button class="mr-r4 customised-icon analyze" style="background-color:white" size="small" @click="openRscSmartAnalyzerPopup"></el-button>
  </el-tooltip>
  <el-tooltip effect="dark" content="기간비교 그래프" placement="bottom">
    <el-button class="mr-r4 customised-icon comparison" style="background-color:white" size="small" @click="openComparePeriodPopup"></el-button>
  </el-tooltip>
  <el-tooltip effect="dark" content="실시간차트" placement="bottom">
    <el-button style="background-color:white" size="small" @click="openRealtimePopup"><i class="fas fa-play text-small" /></el-button>
  </el-tooltip>
  <w-resource-compare-period-popup ref="comparePeriodPopup" :rsc-info-list="rscInfoList"/>
  <w-realtime-chart-popup ref="realtimeChartPopup" />
</span>
</template>

<script>
import { forEach, clone } from 'lodash';
import WResourceComparePeriodPopup from '@/components/popup/ResourceComparePeriodPopup';
import WRealtimeChartPopup from '@/components/popup/RealtimeChartPopup';

/**
 * 분석 차트 도구 컴포넌트
 */
export default {
  name: 'WAnalysisChartTool',
  components: {
    WResourceComparePeriodPopup,
    WRealtimeChartPopup,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rscInfoList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     * 차트 자원에 대한 기간 비교 팝업을 연다.
     * @author Ju
     */
    openComparePeriodPopup() {
      this.$refs.comparePeriodPopup.open();
    },
    /**
     * 자원 스마트 분석 팝업을 연다.
     * @author Ju
     */
    openRscSmartAnalyzerPopup() {
      const objRscKeyList = [];
      forEach(this.rscInfoList, (item) => {
        objRscKeyList.push({
          objId: item.objId,
          managetypeId: item.managetypeId,
          rsctypeId: item.rsctypeId,
          rscId: item.rscId,
          rscKey: item.rscKey,
        });
      });
      this.$store.dispatch('openResourceSmartAnalyzerPopup', objRscKeyList);
    },
    /**
     * 실시간 차트 팝업을 연다
     */
    openRealtimePopup() {
      const obj = this.rscInfoList[0];
      const newCharts = [];

      const rscInfoList = [[{
        objId: obj.objId,
        managetypeId: obj.managetypeId,
        rsctypeId: obj.rsctypeId,
        rscId: obj.rscId,
        rscKey: '_',
        orderbyIndex: 1,
      }]];

      forEach(rscInfoList, (rscInfo) => {
        newCharts.push({
          items: clone(rscInfo),
          visible: true,
          added: true,
        });
      });
      // this.orderbyChart(chartRscList, dropIndex, newCharts);
      const chartRscList = { ...newCharts };
      this.chartRscList = chartRscList;
      this.$refs.realtimeChartPopup.open(this.chartRscList);
    },

    orderbyChart(chartRscList, dropIndex, newCharts) {
      chartRscList.splice(dropIndex, 0, ...newCharts);
      for (let i = 0; i < chartRscList.length; i += 1) {
        chartRscList[i].orderbyIndex = i;
      }

      this.chartRscList = chartRscList;
      this.$emit('setChartList', chartRscList);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/AnalysisChartTool.vue